import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'lib-spinner',
  imports: [MatProgressSpinnerModule],
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  @Input()
  percentage?: number | null;
  @Input()
  size?: 100 | 50 | 30 | 20;
}
